import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ButtonBase, Typography } from "@mui/material";
import type { ButtonBaseProps } from "@mui/material";
import { Box } from "@mui/system";
import type { JSX } from "react";

type BackButtonProps = ButtonBaseProps & {
  label: string;
  onClick: () => void;
};

export const BackButton = ({ label, onClick, ...buttonProps }: BackButtonProps): JSX.Element => (
  <ButtonBase
    onClick={onClick}
    {...buttonProps}
    sx={{
      flexShrink: 0,
      gap: "10px",
      alignItems: "center",
      pr: "14px",
      py: "1px",
      color: (theme) => theme.semanticColors.interactive.primary,
    }}
  >
    <ArrowBackIcon sx={{ fontSize: "18px" }} />

    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        py: "10px",
      }}
    >
      <Typography
        sx={(theme) => ({
          fontFamily: theme.typography.fontFamily,
          fontSize: "14px",
          lineHeight: "20px",
          fontWeight: 600,
          color: theme.semanticColors.interactive.primary,
          whiteSpace: "nowrap",
        })}
      >
        {label}
      </Typography>
    </Box>
  </ButtonBase>
);
